import { Avatar, Typography } from "@material-ui/core";
import React from "react";
import Badge from "../../../../components/common/PL/Badge/Badge";
import { getInitials } from "../../../../components/common/PL/Table/utils/getInitials";
import useStyles from "./ReservationGuestCardStyles";

interface ReservationGuestCardProps {
  name: string;
  initials?: string;
  franja?: string;
  menu?: string;
  primerIngreso?: string;
}

export const ReservationGuestCard = ({
  name,
  initials,
  franja,
  menu,
  primerIngreso,
}: ReservationGuestCardProps) => {
  const classes = useStyles();
  const hasDetails = Boolean(franja || menu || primerIngreso);

  return (
    <div className={`${classes.root} ${hasDetails ? classes.rootDetailed : classes.rootSimple}`}>
      <div className={`${classes.header} ${hasDetails ? classes.headerDetailed : ""}`}>
        <Avatar className={classes.avatar}>{initials || getInitials(name, "")}</Avatar>
        <div className={classes.info}>
          <Typography className={classes.name}>{name}</Typography>
        </div>
      </div>

      {franja && (
        <div className={classes.row}>
          <Typography className={classes.label}>FRANJA</Typography>
          <Typography className={classes.value}>{franja}</Typography>
        </div>
      )}

      {menu && (
        <div className={classes.row}>
          <Typography className={classes.label}>MENÚ</Typography>
          <Badge label={menu} variant="green" />
        </div>
      )}

      {primerIngreso && (
        <div className={classes.row}>
          <Typography className={classes.label}>PRIMER INGRESO</Typography>
          <Badge label={primerIngreso} variant="yellow" />
        </div>
      )}
    </div>
  );
};
